import React from 'react';

import { useFormikContext } from 'formik';

import Button from 'CommonComponents/Button';

const ProjectActivityFormFooter = ({ onCancel }) => {
    const { isSubmitting, handleSubmit } = useFormikContext();

    // `!` because a parent's tw-space-y-* margin outranks tw-mt-auto, which would unpin the footer.
    return (
        <div className="modal__footer !tw-mt-auto tw-pt-6">
            <Button variant="secondary" onClick={onCancel} disabled={isSubmitting}>
                {$t('Cancel')}
            </Button>
            <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                {$t('Save')}
            </Button>
        </div>
    );
};

export default ProjectActivityFormFooter;
